export default "__VITE_ASSET__Ca8u9IVE__"